var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVasIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "prefix__Rectangle_2512",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2512",
    transform: "translate(42 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2514",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2514",
    transform: "translate(42 10)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__sliders-h-square",
    d: "M14.286 0H1.714A1.715 1.715 0 000 1.714v12.572A1.715 1.715 0 001.714 16h12.572A1.715 1.715 0 0016 14.286V1.714A1.715 1.715 0 0014.286 0zm-.214 14.286H1.929a.215.215 0 01-.214-.214V1.928a.215.215 0 01.214-.214h12.142a.215.215 0 01.214.214v12.143a.215.215 0 01-.214.215zm-1.5-6.143v.286a.43.43 0 01-.429.429h-.714v.857a.855.855 0 01-.857.857H10a.855.855 0 01-.857-.857v-.858H3.857a.43.43 0 01-.429-.429v-.285a.43.43 0 01.429-.429h5.286v-.857A.855.855 0 0110 6h.571a.855.855 0 01.858.857v.857h.714a.43.43 0 01.428.429z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasIcon);
export default __webpack_public_path__ + "static/media/vas-icon.1c0d660204fb1afbe235940227dc167e.svg";
export { ForwardRef as ReactComponent };